import User from "models/user/user";

import Pusher from "pusher-js";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  allDiaries,
  arciveDiaries,
  currentDiaryDetail,
  currentDiaryTopic,
  diaryEntries,
  diaryStatus,
  fetchAllArchiveDiaries,
  fetchAllDiaries,
  saveAllArchiveDiaries,
  saveAllDiaries,
  saveCurrentDiary,
  saveCurrentDiaryDetail,
  saveDiaryStatus,
  saveNewArchivedDiary,
  saveNewMessage,
  saveNewlyCreatedDiary,
  saveOneDiaryEntry,
  saveTopEntryId,
} from "redux/diaries/diariesSlice";
import {
  saveNotificationCount,
  saveNotifications,
} from "redux/notification/notificationSlice";

export default function PusherNotification() {
  const id = User.getUserId();
  const dispatch = useDispatch();
  const diaryDetail = useSelector(currentDiaryDetail);
  const DiaryEntries = useSelector(diaryEntries);
  const selected = useSelector(currentDiaryTopic);
  const diaries = useSelector(allDiaries);
  const navigate = useNavigate();
  const currStatus = useSelector(diaryStatus);
  const archiveDiaries = useSelector(arciveDiaries);

  const addUserEntry = (value) => {
    const obj = JSON.parse(value[0]?.Body);
    if (diaryDetail?.diaryId === obj?.DiaryId) {
      if (selected?.topicId === obj?.DiaryTopicId) {
        const newEntry = {
          createdAt: obj?.CreatedAt,
          diaryEntryId: obj?.DiaryEntryId,
          diaryTopicId: obj?.DiaryTopicId,
          isReleased: obj?.IsReleased,
          releasedEntryId: obj?.ReleasedEntryId,
          replyToEntryId: obj?.ReplyToEntryId,
          text: obj?.Text,
          user: {
            email: obj?.Email,
            firstName: obj?.FirstName,
            lastName: obj?.LastName,
            roleId: obj?.RoleId,
            userId: obj?.UserId,
          },
        };
        dispatch(saveTopEntryId(null));
        dispatch(saveOneDiaryEntry(newEntry));
        dispatch(saveNewMessage(obj?.DiaryEntryId));
      }
      let diary = { ...diaryDetail };
      const topicIndex = diaryDetail?.topics.findIndex((e) =>
        e.diaryTopicId
          ? e.diaryTopicId === obj?.DiaryTopicId
          : e.id === obj?.DiaryTopicId
      );
      const diaryTopic = [...diary.topics];
      diaryTopic[topicIndex] = {
        ...diaryTopic[topicIndex],
        lastEntrySenderId: obj?.UserId,
        lastEntryTimestamp: obj?.CreatedAt,
      };
      diary = { ...diary, topics: [...diaryTopic] };
      dispatch(saveCurrentDiaryDetail(diary));
    }
    const temp = [...diaries];
    const index = temp?.findIndex((e) => e?.diaryId === obj?.DiaryId);
    const tempTopics = [...temp[index]?.topics];
    const topicIndex = tempTopics.findIndex((e) => e?.id === obj?.DiaryTopicId);
    if (selected?.topicId !== obj?.DiaryTopicId) {
      tempTopics[topicIndex] = {
        ...tempTopics[topicIndex],
        unseenMessageCount: tempTopics[topicIndex]?.unseenMessageCount + 1,
        lastEntrySenderId: obj?.UserId,
        lastEntryTimestamp: obj?.CreatedAt,
      };
      temp[index] = {
        ...temp[index],
        topics: [...tempTopics],
        totalUnseenMessageCountInDiary:
          temp[index]?.totalUnseenMessageCountInDiary + 1,
      };
    } else {
      tempTopics[topicIndex] = {
        ...tempTopics[topicIndex],
        lastEntrySenderId: obj?.UserId,
        lastEntryTimestamp: obj?.CreatedAt,
      };
      temp[index] = {
        ...temp[index],
        topics: [...tempTopics],
      };
    }
    // To shift the latest to top
    const [movedObject] = temp.splice(index, 1);
    temp.unshift(movedObject);
    diaryDetail?.diaryId === obj?.DiaryId &&
      dispatch(saveDiaryStatus({ diary: temp[index] }));

    dispatch(saveAllDiaries(temp));
  };

  const changeDiaryStatus = (value) => {
    const obj = JSON.parse(value[0]?.Body);
    if (selected?.diaryId === obj?.DiaryId) {
      const text = value[0]?.message ?? value[0]?.Message;
      const split = text.split("has")[1].split(" ")[1];
      split === "Accepted" && navigate("/");
      let temp = {
        ...currStatus.diary,
        status: {
          ...currStatus?.status,
          id: split === "Accepted" ? 1 : split === "invited" ? 3 : 2,
          name: split,
        },
      };
      if (split === "invited") {
        temp = { ...temp, isCreator: false };
      }
      dispatch(saveDiaryStatus({ diary: temp }));
    }
  };

  const archiveUnarchiveUpdate = (value) => {
    const obj = JSON.parse(value[0]?.Body);
    if (obj?.Type === "requested" || obj?.Type === "declined") {
      if (obj?.Action === "archive") {
        dispatch(
          fetchAllDiaries(
            true,
            selected?.diaryId === obj?.DiaryId ? selected?.diaryId : null
          )
        );
        // whenever this selected?.diaryId === obj?.DiaryId get, in fetchAllDiaries then it updated the saveDiary Status after fetching the listing
      } else {
        dispatch(fetchAllArchiveDiaries());
        dispatch(fetchAllDiaries(true, null));
        if (selected?.diaryId === obj?.DiaryId) {
          navigate(
            `/journal-request${
              obj?.Type === "declined" ? "" : "?archived=true"
            }`
          );
          dispatch(saveDiaryStatus({}));
          dispatch(saveCurrentDiary({}));
        }
      }
    } else {
      if (selected?.diaryId === obj?.DiaryId && obj?.Action === "archive") {
        navigate(`/journal-request`);
        dispatch(saveDiaryStatus({}));
        dispatch(saveCurrentDiary({}));
        dispatch(fetchAllDiaries(true, null));
      } else {
        dispatch(
          fetchAllDiaries(
            true,
            selected?.diaryId === obj?.DiaryId ? selected?.diaryId : null
          )
        );
      }
      dispatch(fetchAllArchiveDiaries());
    }
  };

  useEffect(() => {
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    });

    // const channelLockUnlock = pusher.subscribe(`diary-lock-unlock-${id}`);
    const channelDiaryInvite = pusher.subscribe(`diary-invite-${id}`);
    const channelInviteStatus = pusher.subscribe(`diary-invite-status-${id}`);
    const channelDiaryTopic = pusher.subscribe(`diary-new-topic-${id}`);
    const channelDiaryEntries = pusher.subscribe(`diary-new-entry-${id}`);
    const channelUnlockLockRequest = pusher.subscribe(
      `diary-unlock-request-${id}`
    );
    const channelArchiveUnArchive = pusher.subscribe(
      `diary-archive-unarchive-${id}`
    );

    channelDiaryInvite.bind("notification", (data) => {
      dispatch(fetchAllDiaries(true));
      changeDiaryStatus(data);
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
    });

    channelInviteStatus.bind("notification", (data) => {
      dispatch(fetchAllDiaries(true));
      changeDiaryStatus(data);
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
    });

    channelDiaryTopic.bind("notification", (data) => {
      dispatch(fetchAllDiaries(true));
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
    });

    channelDiaryEntries.bind("notification", (data) => {
      addUserEntry(data);
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
    });

    channelUnlockLockRequest.bind("notification", (data) => {
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
    });
    channelArchiveUnArchive.bind("notification", (data) => {
      dispatch(saveNotificationCount("plus"));
      dispatch(saveNotifications(data));
      archiveUnarchiveUpdate(data);
    });

    return () => {
      pusher.unsubscribe(`diary-lock-unlock-${id}`);
      pusher.unsubscribe(`diary-invite-${id}`);
      pusher.unsubscribe(`diary-invite-status-${id}`);
      pusher.unsubscribe(`diary-new-topic-${id}`);
      pusher.unsubscribe(`diary-new-entry-${id}`);
      pusher.unsubscribe(`diary-unlock-request-${id}`);
      pusher.unsubscribe(`diary-archive-unarchive-${id}`);

      pusher.disconnect();
    };
  }, [diaryDetail, DiaryEntries, selected, diaries]);
}
